/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Definition of the monitor scope of the notification rule
 */
export type PublicNotificationRuleMonitorScopeDto = {
    /**
     * Type of the notification rule monitor scope
     */
    type: PublicNotificationRuleMonitorScopeDto.type;
};

export namespace PublicNotificationRuleMonitorScopeDto {

    /**
     * Type of the notification rule monitor scope
     */
    export enum type {
        ALL = 'ALL',
        FILTERED = 'FILTERED',
    }


}
